export default __webpack_public_path__ + "static/media/JUNIA-ISEN-300x89.ba5f23ea.jpg";